import { useState, useEffect, useRef } from 'react';

/**
 * Track Shift key state. Returns both a ref (for non-rendering reads)
 * and a state boolean (for rendering-dependent reads).
 */
export const useShiftKey = () => {
  const ref = useRef(false);
  const [state, setState] = useState(false);

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'Shift') {
        ref.current = true;
        setState(true);
      }
    };
    const up = (e: KeyboardEvent) => {
      if (e.key === 'Shift') {
        ref.current = false;
        setState(false);
      }
    };
    window.addEventListener('keydown', down);
    window.addEventListener('keyup', up);
    return () => {
      window.removeEventListener('keydown', down);
      window.removeEventListener('keyup', up);
    };
  }, []);

  return { ref, state };
};
